import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getHeroList, getGwDefenseList, deleteGwDefense } from '../../api/senaApi';
import { heroPortrait, skillImg as senaSkillImg, skillLabel } from './senaAssets';
import './SenaGuildWar.css';

const skillImg = (heroNm, skillNo) => senaSkillImg(heroNm, 'ALLY', skillNo);

// 등록된 방어 덱 목록 — 카드를 누르면 그 자리에서 상세가 아래로 펼쳐진다.
export default function SenaGwDefense() {
  const navigate = useNavigate();
  const userId = localStorage.getItem('userId');
  const userRole = localStorage.getItem('userRole');

  const [allyHeroes, setAllyHeroes] = useState([]);
  const [decks, setDecks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openId, setOpenId] = useState(null);   // 펼쳐진 덱

  useEffect(() => {
    getHeroList('ALLY').then(r => setAllyHeroes(r.data || [])).catch(() => {});
    fetchDecks();
  }, []);

  const fetchDecks = () => {
    setLoading(true);
    getGwDefenseList()
      .then(r => setDecks(r.data || []))
      .catch(() => setDecks([]))
      .finally(() => setLoading(false));
  };

  const canModify = (deck) => userId === deck.authorNm || userRole === 'ADMIN';

  const handleDelete = (deck) => {
    if (!window.confirm('방어 덱을 삭제하시겠습니까?')) return;
    deleteGwDefense(deck.defenseId)
      .then(() => {
        setDecks(prev => prev.filter(d => d.defenseId !== deck.defenseId));
        if (openId === deck.defenseId) setOpenId(null);
      })
      .catch(e => alert(e?.response?.data || '삭제 실패'));
  };

  // 스킬ID → 영웅명/스킬번호
  const findSkillInfo = (skillIdStr) => {
    const skillId = Number(skillIdStr);
    for (const hero of allyHeroes) {
      const sk = (hero.skills || []).find(s => s.skillId === skillId);
      if (sk) return { heroNm: hero.heroNm, skillNo: sk.skillNo };
    }
    return { heroNm: '?', skillNo: 0 };
  };

  const renderSkillChip = (skillIdStr, order) => {
    const info = findSkillInfo(skillIdStr);
    const img = skillImg(info.heroNm, info.skillNo);
    return (
      <div key={`${skillIdStr}-${order}`} className="gw-skill-chip ally">
        <span className="gw-skill-chip-order">{order}</span>
        {img ? <img className="gw-skill-chip-img" src={img} alt="" /> : null}
        <span className="gw-skill-chip-text">{info.heroNm} {skillLabel(info.skillNo)}</span>
      </div>
    );
  };

  const heroRows = (deck) => [
    { heroNm: deck.hero1Nm, note: deck.note1 },
    { heroNm: deck.hero2Nm, note: deck.note2 },
    { heroNm: deck.hero3Nm, note: deck.note3 },
  ];

  return (
    <div className="sena-page">
      <header className="sena-header">
        <button className="siege-back-btn" onClick={() => navigate('/sena')}>← 메인으로</button>
        <h1 className="sena-header-guild">길드전(방어)</h1>
        <p className="sena-header-sub">방어 덱 세팅</p>
      </header>

      <div className="gw-def-body">
        <div className="gw-def-toolbar">
          <span className="gw-def-count">{decks.length}건</span>
          <button className="gw-war-write-btn" onClick={() => navigate('/sena/gw/defense/write')}>덱 등록</button>
        </div>

        {loading ? (
          <p className="gw-war-empty">조회 중...</p>
        ) : decks.length === 0 ? (
          <p className="gw-war-empty">등록된 방어 덱이 없습니다.</p>
        ) : (
          <div className="gw-def-list">
            {decks.map(deck => {
              const open = openId === deck.defenseId;
              const skillIds = (deck.skillIds || '').split(',').filter(Boolean);
              return (
                <div key={deck.defenseId} className={`gw-def-item ${open ? 'open' : ''}`}>
                  {/* 요약 줄 — 누르면 아래로 펼쳐진다 */}
                  <div className="gw-def-head" onClick={() => setOpenId(open ? null : deck.defenseId)}>
                    <span className="gw-def-toggle">{open ? '▾' : '▸'}</span>
                    <div className="gw-def-heroes">
                      {heroRows(deck).map((h, i) => {
                        const img = heroPortrait(h.heroNm, 'ALLY');
                        return (
                          <span key={i} className="gw-def-hero-tag">
                            {img && <img className="gw-def-hero-portrait" src={img} alt="" />}
                            {h.heroNm}
                          </span>
                        );
                      })}
                    </div>
                    <span className="gw-war-deck-author">{deck.authorDisplayNm || deck.authorNm}</span>
                    {canModify(deck) && (
                      <span className="gw-def-actions">
                        <button className="gw-war-write-btn gw-def-btn-sm"
                          onClick={(e) => { e.stopPropagation(); navigate(`/sena/gw/defense/write?id=${deck.defenseId}`); }}>
                          수정
                        </button>
                        <button className="gw-war-del-btn"
                          onClick={(e) => { e.stopPropagation(); handleDelete(deck); }}>
                          삭제
                        </button>
                      </span>
                    )}
                  </div>

                  {/* 상세 */}
                  {open && (
                    <div className="gw-def-detail">
                      <div className="gw-war-case-group">
                        <h3 className="gw-war-case-group-title">영웅 세팅</h3>
                        <div className="gw-war-note-list">
                          {heroRows(deck).map((h, i) => (
                            <div key={i} className="gw-war-note-row">
                              <span className="gw-war-note-hero">
                                {heroPortrait(h.heroNm, 'ALLY') && (
                                  <img className="gw-war-note-portrait" src={heroPortrait(h.heroNm, 'ALLY')} alt="" />
                                )}
                                {h.heroNm}
                              </span>
                              {h.note
                                ? <span className="gw-war-note-text">{h.note}</span>
                                : <span className="gw-war-note-text empty">— 비고 없음</span>}
                            </div>
                          ))}
                        </div>
                      </div>

                      <div className="gw-war-case-group">
                        <h3 className="gw-war-case-group-title">스킬 순서</h3>
                        {skillIds.length === 0 ? (
                          <p className="gw-hint">지정된 스킬이 없습니다.</p>
                        ) : (
                          <div className="gw-war-case-skills">
                            {skillIds.map((id, i) => renderSkillChip(id, i + 1))}
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
